<div class="content-wrapper-col2-vf">
  <div>
    <!-- Left column -->
    <div class="col-wrap-v">      
      <app-source-editor-new 
        [data]="data" 
        (onCompleted)="onSourceEditorCompleted($event)"
        class="editor-panel">
      </app-source-editor-new>
    </div>

    <!-- Right column -->
    <div class="col-wrap-f">
      <app-source-list
        #sourceListRef
        [data]="data"
        [selectedSourceId]="highlightedSourceId"
        (onCompleted)="onSourceListCompleted($event)"
        class="list-panel">
      </app-source-list>
    </div>
  </div>
</div>
